{
  "chart": "Rekam Medis Pasien",
  "mrn": "MRN",
  "demographics": {
    "pageTitle": "Data Demografis",
    "loading": "Memuat data demografis pasien...",
    "loadError": "Gagal memuat data demografis pasien.",
    "returnToDashboard": "Kembali ke Dasbor",
    "updatedSuccess": "Data demografis pasien telah diperbarui",
    "updateError": "Gagal memperbarui data demografis pasien",
    "sections": {
      "personalInformation": "Informasi Pribadi",
      "identification": "Identifikasi",
      "contactInformation": "Informasi Kontak",
      "address": "Alamat",
      "languageAndPreferences": "Bahasa & Preferensi",
      "specialFlags": "Tanda Khusus",
      "recordInformation": "Informasi Rekam Medis"
    },
    "fields": {
      "fullName": "Nama Lengkap",
      "alternativeName": "Nama Alternatif",
      "preferredName": "Nama Panggilan",
      "dateOfBirth": "Tanggal Lahir",
      "birthTime": "Waktu Lahir",
      "age": "Usia",
      "legalGender": "Jenis Kelamin Resmi",
      "genderIdentity": "Identitas Gender",
      "sexAtBirth": "Jenis Kelamin Saat Lahir",
      "race": "Ras",
      "ethnicity": "Suku Bangsa",
      "nationality": "Kewarganegaraan",
      "mrn": "MRN",
      "nationalIdType": "Jenis Identitas",
      "nationalIdNumber": "Nomor Identitas",
      "passportNumber": "Nomor Paspor",
      "passportCountry": "Negara Penerbit Paspor",
      "primaryPhone": "Telepon Utama",
      "mobilePhone": "Telepon Seluler",
      "email": "Email",
      "preferredContactMethod": "Metode Kontak Pilihan",
      "addressLine1": "Alamat Baris 1",
      "addressLine2": "Alamat Baris 2",
      "city": "Kota",
      "stateProvince": "Provinsi",
      "postalCode": "Kode Pos",
      "country": "Negara",
      "primaryLanguage": "Bahasa Utama",
      "secondaryLanguage": "Bahasa Kedua",
      "interpreterRequired": "Memerlukan Penerjemah",
      "vipStatus": "Status VIP",
      "confidentialityLevel": "Tingkat Kerahasiaan",
      "medicalTourist": "Wisatawan Medis",
      "homeCountry": "Negara Asal",
      "status": "Status",
      "deceased": "Meninggal",
      "created": "Dibuat",
      "lastModified": "Terakhir Diubah",
      "passportOnFile": "Paspor Tersimpan",
      "organDonorStatus": "Status Donor Organ"
    },
    "statusValues": {
      "active": "Aktif",
      "inactive": "Tidak Aktif"
    },
    "deceasedSummary": "Ya ({{date}})",
    "deceasedDateUnknown": "Tanggal tidak diketahui",
    "legalGender": {
      "label": "Jenis Kelamin Resmi",
      "values": {
        "male": "Laki-laki",
        "female": "Perempuan",
        "other": "Lainnya",
        "unknown": "Tidak Diketahui"
      },
      "selectPlaceholder": "Pilih Jenis Kelamin"
    },
    "sexAtBirth": {
      "label": "Jenis Kelamin Saat Lahir",
      "values": {
        "female": "Perempuan",
        "male": "Laki-laki",
        "other": "Lainnya",
        "unknown": "Tidak diketahui"
      },
      "notRecorded": "Tidak tercatat"
    },
    "preferredContactMethod": {
      "label": "Metode Kontak Pilihan",
      "values": {
        "phone": "Telepon",
        "mobile": "Seluler",
        "email": "Email",
        "sms": "SMS"
      },
      "notSpecified": "Belum ditentukan"
    },
    "validation": {
      "fullNameRequired": "Nama lengkap wajib diisi",
      "dateOfBirthRequired": "Tanggal lahir wajib diisi",
      "countryRequired": "Negara wajib diisi",
      "primaryLanguageRequired": "Bahasa utama wajib diisi",
      "invalidEmail": "Email tidak valid",
      "nationalIdValidationFailed": "Validasi nomor identitas gagal: {{error}}",
      "invalidBirthTime": "Waktu lahir harus dalam format HH:MM"
    },
    "organDonor": {
      "notRecorded": "Belum dicatat",
      "registered": "Terdaftar sebagai donor",
      "optedOut": "Menolak donasi",
      "notRegistered": "Belum terdaftar",
      "unknown": "Tidak diketahui"
    }
  },
  "registration": {
    "title": "Pendaftaran Pasien",
    "subtitle": "Daftarkan pasien baru ke dalam sistem",
    "submit": "Daftarkan Pasien",
    "submitting": "Mendaftarkan...",
    "checkingDuplicates": "Memeriksa duplikat...",
    "registerNew": "Daftarkan Pasien Baru",
    "registeredSuccess": "Pasien berhasil didaftarkan",
    "registerError": "Gagal mendaftarkan pasien",
    "validationNationalIdFailed": "Validasi nomor identitas gagal: {{error}}",
    "sections": {
      "basicInformation": "Informasi Dasar",
      "identification": "Identifikasi",
      "contactInformation": "Informasi Kontak",
      "address": "Alamat",
      "languageAndCommunication": "Bahasa & Komunikasi",
      "additionalInformation": "Informasi Tambahan"
    },
    "fields": {
      "facility": "Fasilitas pendaftaran"
    },
    "placeholders": {
      "fullName": "Mis. Budi Santoso atau 李小明",
      "alternativeName": "Versi latin (jika ada)",
      "preferredName": "Nama panggilan yang disukai pasien",
      "nationalIdNumberDefault": "Masukkan nomor identitas",
      "primaryPhone": "+62 812 3456 7890",
      "mobilePhone": "+62 812 3456 7890",
      "email": "patient@example.com",
      "facility": "Pilih fasilitas"
    },
    "helperText": {
      "fullName": "Isi nama lengkap sesuai dokumen resmi",
      "facility": "Fasilitas tempat pasien ini didaftarkan. Staf di sana akan dapat membuka rekam medis tersebut."
    },
    "flags": {
      "vipPatient": "Pasien VIP",
      "medicalTourist": "Wisatawan Medis"
    },
    "duplicate": {
      "title": "Ditemukan Pasien yang Mungkin Duplikat",
      "body": "Pasien yang sudah ada berikut cocok dengan informasi yang Anda masukkan:",
      "mrnLabel": "MRN",
      "dobLabel": "DOB",
      "idLabel": "ID",
      "matchSummary": "Kecocokan: {{score}}% ({{reasons}})",
      "useExisting": "Gunakan yang Sudah Ada",
      "createNew": "Ini Pasien Baru",
      "restricted": {
        "title_one": "Ada {{count}} kemungkinan kecocokan yang tidak dapat Anda lihat",
        "title_other": "Ada {{count}} kemungkinan kecocokan yang tidak dapat Anda lihat",
        "body": "Pasien ini mungkin sudah memiliki rekam medis di fasilitas lain. Hubungi Manajemen Informasi Kesehatan sebelum membuat yang baru — detail disembunyikan karena rekam medis tersebut di luar akses Anda."
      },
      "overrideReasonLabel": "Alasan tetap mendaftarkan",
      "overrideReasonPlaceholder": "mis. dikonfirmasi dengan pasien bahwa ini orang yang berbeda",
      "overrideReasonHelp": "Dicatat atas akun Anda. Membuat rekam medis kedua untuk orang yang sama memecah riwayatnya.",
      "registerAnyway": "Tetap daftarkan"
    }
  },
  "search": {
    "title": "Cari Pasien",
    "subtitle": "Cari dan kelola rekam medis pasien",
    "placeholder": "Cari berdasarkan nama pasien, MRN, atau ID...",
    "advancedFilters": "Filter Lanjutan",
    "filters": {
      "mrnPlaceholder": "Mis. P0000000001",
      "fullNamePlaceholder": "Nama pasien",
      "phonePlaceholder": "Nomor telepon",
      "emailPlaceholder": "Alamat email"
    },
    "filterLabels": {
      "mrn": "MRN",
      "fullName": "Nama Lengkap",
      "dateOfBirth": "Tanggal Lahir",
      "phone": "Telepon",
      "email": "Email",
      "country": "Negara",
      "status": "Status",
      "vip": "VIP"
    },
    "vipFilter": {
      "all": "Semua",
      "vipOnly": "Hanya VIP",
      "nonVipOnly": "Hanya Non-VIP"
    },
    "statusFilter": {
      "all": "Semua",
      "active": "Aktif",
      "inactive": "Tidak Aktif"
    },
    "countryFilter": {
      "all": "Semua Negara"
    },
    "clearFilters": "Bersihkan Filter",
    "dateOfBirthAria": "Filter tanggal lahir",
    "columns": {
      "mrn": "MRN",
      "fullName": "Nama Lengkap",
      "dob": "DOB",
      "gender": "Jenis Kelamin",
      "phone": "Telepon",
      "country": "Negara",
      "status": "Status"
    },
    "results": {
      "searching": "Mencari pasien...",
      "loadError": "Gagal memuat pasien. Silakan coba lagi.",
      "retry": "Coba lagi",
      "empty": "Tidak ada pasien ditemukan. Coba sesuaikan kriteria pencarian.",
      "showing": "Menampilkan {{from}} – {{to}} dari {{total}} pasien"
    }
  },
  "myPatients": {
    "title": "Pasien Saya",
    "subtitle": "Pasien aktif dalam perawatan Anda",
    "searchPlaceholder": "Saring berdasarkan nama atau MRN...",
    "columns": {
      "mrn": "MRN",
      "patient": "Nama Lengkap",
      "dob": "DOB",
      "sex": "Jenis Kelamin",
      "class": "Kelas",
      "relationship": "Hubungan",
      "admitted": "Tanggal Masuk"
    },
    "kind": {
      "attending": "Penanggung Jawab",
      "careTeam": "Tim perawatan",
      "referral": "Rujukan",
      "coverage": "Pengganti jaga"
    },
    "restrictedBadge": "Terbatas",
    "empty": {
      "title": "Tidak ada pasien di panel Anda",
      "body": "Pasien yang Anda rawat, gantikan, atau terima melalui rujukan akan tampil di sini.",
      "censusAction": "Buka papan tempat tidur"
    },
    "results": {
      "searching": "Memuat pasien Anda...",
      "loadError": "Gagal memuat pasien Anda. Silakan coba lagi.",
      "retry": "Coba lagi",
      "showing": "Menampilkan {{from}} – {{to}} dari {{total}} pasien"
    }
  },
  "encounters": {
    "title": "Kunjungan",
    "create": "Buat Kunjungan",
    "filters": "Filter",
    "filterLabels": {
      "status": "Status",
      "class": "Kelas",
      "fromDate": "Dari Tanggal",
      "toDate": "Hingga Tanggal"
    },
    "filterPlaceholders": {
      "allStatuses": "Semua Status",
      "allClasses": "Semua Kelas"
    },
    "clearFilters": "Bersihkan Filter",
    "fromDateAria": "Dari Tanggal",
    "toDateAria": "Hingga Tanggal",
    "columns": {
      "encounterNumber": "No. Kunjungan",
      "class": "Kelas",
      "status": "Status",
      "admitDate": "Tanggal Masuk",
      "dischargeDate": "Tanggal Pulang",
      "location": "Lokasi",
      "chiefComplaint": "Keluhan Utama"
    },
    "locationLabel": "Lokasi #{{id}}",
    "loading": "Memuat kunjungan...",
    "loadError": "Gagal memuat kunjungan.",
    "empty": "Pasien ini belum memiliki kunjungan.",
    "showing": "Menampilkan {{from}} – {{to}} dari {{total}}"
  },
  "identifiers": {
    "nationalIdType": {
      "label": "Jenis Identitas",
      "none": "Tidak Ada",
      "values": {
        "nric": "NRIC",
        "hkid": "HKID",
        "myKad": "MyKad",
        "aadhaar": "Aadhaar",
        "ktp": "KTP",
        "myNumber": "My Number",
        "thaiNationalId": "KTP Thailand"
      },
      "country": {
        "nric": "Singapura",
        "hkid": "Hong Kong",
        "myKad": "Malaysia",
        "aadhaar": "India",
        "ktp": "Indonesia",
        "myNumber": "Jepang",
        "thaiNationalId": "Thailand"
      },
      "placeholderByType": {
        "nric": "Mis. S1234567D",
        "myKad": "Mis. 850101-14-5678",
        "hkid": "Mis. A123456(3)",
        "aadhaar": "Mis. 2341 2341 2346",
        "thaiNationalId": "Mis. 1-2345-45678-78-1"
      }
    },
    "nationalIdCheck": {
      "checksumMismatch": "Karakter pemeriksa tidak cocok untuk jenis identitas ini. Periksa nomor dengan dokumen identitas pasien.",
      "unavailable": "Nomor identitas ini tidak dapat diperiksa. Periksa nomor dengan dokumen identitas pasien.",
      "acknowledge": "Saya telah memeriksa nomor ini dengan dokumen identitas",
      "acknowledgeRequired": "Periksa nomor identitas dengan dokumen identitas dan konfirmasi sebelum menyimpan."
    }
  },
  "country": {
    "values": {
      "sg": "Singapura",
      "my": "Malaysia",
      "th": "Thailand",
      "id": "Indonesia",
      "ph": "Filipina",
      "vn": "Vietnam",
      "hk": "Hong Kong",
      "tw": "Taiwan",
      "jp": "Jepang",
      "kr": "Korea Selatan",
      "cn": "Tiongkok",
      "in": "India",
      "au": "Australia",
      "nz": "Selandia Baru"
    }
  },
  "language": {
    "values": {
      "en": "Inggris",
      "zh": "Tionghoa (Mandarin)",
      "ms": "Melayu",
      "ta": "Tamil",
      "th": "Thai",
      "id": "Indonesia",
      "vi": "Vietnam",
      "ja": "Jepang",
      "ko": "Korea",
      "hi": "Hindi"
    }
  },
  "contact": {
    "addTitle": "Tambah Kontak",
    "editTitle": "Edit Kontak",
    "name": "Nama",
    "relationship": {
      "label": "Hubungan",
      "selectPlaceholder": "Pilih...",
      "values": {
        "spouse": "Pasangan",
        "parent": "Orang Tua",
        "child": "Anak",
        "sibling": "Saudara",
        "guardian": "Wali",
        "friend": "Teman",
        "other": "Lainnya"
      }
    },
    "phone": "Telepon",
    "email": "Email",
    "emergencyContact": "Kontak darurat",
    "validation": {
      "nameRequired": "Nama kontak wajib diisi",
      "relationshipRequired": "Hubungan wajib diisi",
      "phoneRequired": "Nomor telepon wajib diisi",
      "invalidEmail": "Email tidak valid"
    },
    "savedSuccess": "Kontak berhasil ditambahkan",
    "saveError": "Gagal menambahkan kontak"
  },
  "immunization": {
    "addTitle": "Tambah Imunisasi",
    "vaccineName": "Nama Vaksin",
    "vaccineNamePlaceholder": "mis. Influenza, COVID-19 (Pfizer), Hepatitis B",
    "vaccineCode": "Kode Vaksin (CVX)",
    "vaccineCodePlaceholder": "mis. 141",
    "administeredDate": "Tanggal Pemberian",
    "lotNumber": "Nomor Lot",
    "lotNumberPlaceholder": "mis. AB1234",
    "site": {
      "label": "Lokasi",
      "selectPlaceholder": "Pilih lokasi",
      "values": {
        "leftDeltoid": "Deltoid Kiri",
        "rightDeltoid": "Deltoid Kanan",
        "leftThigh": "Paha Kiri",
        "rightThigh": "Paha Kanan",
        "leftGluteal": "Gluteal Kiri",
        "rightGluteal": "Gluteal Kanan",
        "other": "Lainnya"
      }
    },
    "route": {
      "label": "Rute",
      "selectPlaceholder": "Pilih rute",
      "values": {
        "intramuscular": "Intramuskular (IM)",
        "subcutaneous": "Subkutan (SC)",
        "intradermal": "Intradermal (ID)",
        "oral": "Oral",
        "intranasal": "Intranasal"
      }
    },
    "doseAmount": "Dosis",
    "doseAmountPlaceholder": "mis. 0,5 mL",
    "administeredBy": "Diberikan oleh",
    "administeredByPlaceholder": "Nama atau ID petugas",
    "nextDueDate": "Tanggal Pemberian Berikutnya",
    "notes": "Catatan",
    "notesPlaceholder": "Catatan tambahan...",
    "validation": {
      "vaccineNameRequired": "Nama vaksin wajib diisi",
      "administeredDateRequired": "Tanggal pemberian wajib diisi"
    },
    "savedSuccess": "Catatan imunisasi ditambahkan",
    "saveError": "Gagal menambahkan catatan imunisasi"
  },
  "insurance": {
    "addTitle": "Tambah Polis Asuransi",
    "submitLabel": "Tambah Asuransi",
    "payerName": "Nama Penjamin",
    "payerNamePlaceholder": "mis. AIA Singapore",
    "payerId": "ID Penjamin",
    "payerIdPlaceholder": "Pengenal penjamin",
    "planName": "Nama Polis",
    "planNamePlaceholder": "mis. HealthShield Gold Max",
    "planType": {
      "label": "Jenis Polis",
      "selectPlaceholder": "Pilih jenis",
      "values": {
        "hmo": "HMO",
        "ppo": "PPO",
        "epo": "EPO",
        "pos": "POS",
        "government": "Pemerintah",
        "private": "Swasta",
        "corporate": "Korporat",
        "other": "Lainnya"
      }
    },
    "memberId": "ID Anggota",
    "memberIdPlaceholder": "Nomor ID anggota",
    "policyNumber": "Nomor Polis",
    "policyNumberPlaceholder": "Masukkan nomor polis",
    "groupNumber": "Nomor Grup",
    "groupNumberPlaceholder": "Nomor grup",
    "subscriberName": "Nama Tertanggung",
    "subscriberNamePlaceholder": "Jika berbeda dari pasien",
    "subscriberRelationship": {
      "label": "Hubungan dengan Tertanggung",
      "values": {
        "self": "Diri sendiri",
        "spouse": "Pasangan",
        "child": "Anak",
        "parent": "Orang Tua",
        "other": "Lainnya"
      }
    },
    "priority": {
      "label": "Prioritas",
      "values": {
        "primary": "Primer",
        "secondary": "Sekunder",
        "tertiary": "Tersier"
      }
    },
    "effectiveDate": "Tanggal Berlaku",
    "terminationDate": "Tanggal Berakhir",
    "copayAmount": "Biaya Bersama ($)",
    "coinsurancePercent": "Koasuransi (%)",
    "deductibleAmount": "Iuran Sendiri ($)",
    "outOfPocketMax": "Batas Bayar Sendiri ($)",
    "preAuthRequired": "Memerlukan Pra-otorisasi",
    "notes": "Catatan",
    "notesPlaceholder": "Catatan tambahan...",
    "validation": {
      "payerNameRequired": "Nama penjamin wajib diisi",
      "planNameRequired": "Nama polis wajib diisi",
      "memberIdRequired": "ID anggota wajib diisi",
      "effectiveDateRequired": "Tanggal berlaku wajib diisi"
    },
    "savedSuccess": "Polis asuransi ditambahkan",
    "saveError": "Gagal menambahkan polis asuransi"
  },
  "problem": {
    "addTitle": "Tambah Masalah",
    "problemName": "Nama Masalah",
    "problemNamePlaceholder": "mis. Diabetes Melitus Tipe 2",
    "icdCode": "Kode ICD-10",
    "icdSearchPlaceholder": "Cari kode atau deskripsi ICD-10...",
    "onsetDate": "Tanggal Onset",
    "severity": {
      "label": "Keparahan",
      "values": {
        "mild": "Ringan",
        "moderate": "Sedang",
        "severe": "Berat"
      }
    },
    "notes": "Catatan",
    "notesPlaceholder": "Catatan klinis tambahan...",
    "validation": {
      "problemNameRequired": "Nama masalah wajib diisi"
    },
    "savedSuccess": "Masalah ditambahkan ke daftar masalah",
    "saveError": "Gagal menambahkan masalah"
  },
  "accounts": {
    "pageTitle": "Akun Pasien",
    "backToDashboard": "Dasbor",
    "searchPatientLabel": "Cari Pasien",
    "searchPlaceholder": "Cari berdasarkan nama atau MRN...",
    "searching": "Mencari...",
    "noPatientsFound": "Pasien tidak ditemukan",
    "loadingAccount": "Memuat akun...",
    "mrnLabel": "MRN",
    "generateStatement": "Buat Pernyataan",
    "statementComingSoon": "Pembuatan pernyataan akan segera hadir",
    "paymentPlan": "Rencana Pembayaran",
    "paymentPlanComingSoon": "Pengaturan rencana pembayaran akan segera hadir",
    "totalCharges": "Total Tagihan",
    "totalPayments": "Total Pembayaran",
    "adjustments": "Penyesuaian",
    "outstandingBalance": "Saldo Tertunggak",
    "transactionHistory": "Riwayat Transaksi",
    "columns": {
      "date": "Tanggal",
      "type": "Jenis",
      "description": "Deskripsi",
      "amount": "Jumlah",
      "balance": "Saldo"
    },
    "transactionType": {
      "label": "Jenis",
      "values": {
        "charge": "Tagihan",
        "payment": "Pembayaran",
        "adjustment": "Penyesuaian"
      }
    },
    "loadingTransactions": "Memuat transaksi...",
    "noTransactionsFound": "Tidak ada transaksi",
    "emptyState": "Cari pasien untuk melihat akunnya"
  },
  "proxies": {
    "title": "Perwakilan Resmi",
    "description": "Pengasuh, wali, dan perwakilan hukum yang diberi wewenang untuk mengakses data portal pasien. Entri yang dicabut disimpan untuk audit.",
    "addProxy": "Tambah Perwakilan",
    "newRelationshipHeading": "Hubungan perwakilan baru",
    "proxyUserId": "ID pengguna perwakilan",
    "proxyUserIdPlaceholder": "ID Pengguna (dari Admin → Pengguna)",
    "proxyUserIdHelper": "Cari di Admin → Pengguna. Komponen pemilih pengguna akan tersedia pada pembaruan berikutnya.",
    "relationship": {
      "label": "Hubungan",
      "values": {
        "parent": "Orang Tua",
        "legalGuardian": "Wali Hukum",
        "spousePartner": "Pasangan / Mitra",
        "adultChild": "Anak Dewasa",
        "powerOfAttorney": "Kuasa Hukum",
        "healthcareAgent": "Wakil Kesehatan"
      }
    },
    "accessLevel": {
      "label": "Tingkat akses",
      "values": {
        "full": "Penuh",
        "limited": "Terbatas",
        "emergency": "Darurat"
      },
      "descriptions": {
        "full": "Seluruh data portal — janji temu, hasil, pesan, formulir.",
        "limited": "Hanya janji temu dan pesan (umum untuk remaja).",
        "emergency": "Setara break-glass bagi wakil kesehatan saat pasien tidak mampu memutuskan."
      }
    },
    "startDate": "Tanggal mulai",
    "endDate": "Tanggal berakhir",
    "startDateAria": "Tanggal mulai berlaku",
    "endDateAria": "Tanggal berakhir berlaku",
    "grantAccess": "Beri akses perwakilan",
    "userIdRequired": "ID pengguna perwakilan diperlukan",
    "createdSuccess": "Hubungan perwakilan dibuat",
    "duplicateError": "Orang ini sudah menjadi perwakilan dengan hubungan tersebut",
    "invalidDataError": "Data perwakilan tidak valid",
    "createError": "Gagal membuat perwakilan",
    "revokedSuccess": "Akses perwakilan dicabut",
    "revokeError": "Gagal mencabut perwakilan",
    "emptyState": "Belum ada perwakilan. Gunakan tombol di atas untuk memberi akses kepada pengasuh, wali, atau wakil kesehatan.",
    "sections": {
      "active": "Aktif ({{count}})",
      "plannedInactive": "Direncanakan / Tidak Aktif ({{count}})",
      "revoked": "Dicabut ({{count}})"
    },
    "userIdFallback": "Pengguna #{{id}}",
    "noEndDate": "(tidak ada tanggal berakhir)",
    "revokedOn": "Dicabut {{date}}",
    "revokeTitle": "Cabut akses perwakilan",
    "confirmRevokeTitle": "Cabut akses perwakilan?",
    "confirmRevokeBody": "{{name}} akan kehilangan akses ke data portal pasien ini secara langsung. Catatan tetap tersimpan dalam jejak audit.",
    "confirmRevokeLabel": "Cabut akses"
  },
  "merge": {
    "title": "Gabung Pasien",
    "description": "Gabungkan catatan pasien yang duplikat. Pasien sumber akan dinonaktifkan dan semua data klinis akan dipindahkan ke pasien target (yang dipertahankan).",
    "sourceLabel": "Pasien Sumber (akan dinonaktifkan)",
    "targetLabel": "Pasien Target (catatan yang dipertahankan)",
    "clearSelection": "Hapus pilihan",
    "searchPlaceholder": "Cari berdasarkan nama, MRN, atau telepon...",
    "fields": {
      "mrn": "MRN",
      "dob": "Tgl Lahir",
      "gender": "Jenis Kelamin",
      "country": "Negara",
      "phone": "Telepon",
      "email": "Email"
    },
    "counts": {
      "encounters": "Kunjungan: {{count}}",
      "allergies": "Alergi: {{count}}",
      "problems": "Masalah: {{count}}"
    },
    "samePatientWarning": "Sumber dan target harus pasien yang berbeda.",
    "comparisonTitle": "Perbandingan Demografi",
    "comparisonSubtitle": "Perbedaan disorot dengan warna amber.",
    "columns": {
      "field": "Bidang",
      "source": "Sumber ({{mrn}})",
      "target": "Target ({{mrn}})"
    },
    "comparisonLabels": {
      "fullName": "Nama Lengkap",
      "mrn": "MRN",
      "dateOfBirth": "Tanggal Lahir",
      "gender": "Jenis Kelamin",
      "phone": "Telepon",
      "email": "Email",
      "country": "Negara",
      "nationalId": "ID Nasional"
    },
    "reasonLabel": "Alasan Penggabungan",
    "reasonPlaceholder": "Alasan menggabungkan catatan ini (wajib)",
    "notesLabel": "Catatan (opsional)",
    "notesPlaceholder": "Catatan tambahan tentang penggabungan ini",
    "mergeButton": "Gabung Pasien",
    "mergeSuccess": "Pasien berhasil digabung",
    "mergeError": "Gagal menggabung pasien",
    "successHeading": "Penggabungan berhasil diselesaikan.",
    "successBodyPrefix": "Pasien {{mrn}} telah dinonaktifkan. Semua data klinis telah dipindahkan ke ",
    "successBodySuffix": ".",
    "confirmTitle": "Konfirmasi Penggabungan Pasien",
    "confirmBodyPrefix": "Tindakan ini ",
    "confirmBodyEmphasis": "TIDAK DAPAT dibatalkan",
    "confirmBodySuffix": ". Pasien {{sourceMrn}} ({{sourceName}}) akan dinonaktifkan dan semua data klinis akan dipindahkan ke Pasien {{targetMrn}} ({{targetName}}).",
    "confirmButton": "Ya, Gabung Pasien",
    "swapSides": "Swap source and target",
    "preloadError": "Could not load the selected records.",
    "detailLoadError": "Catatan pasien tidak dapat dimuat."
  },
  "allergy": {
    "addTitle": "Tambah Alergi",
    "editTitle": "Ubah Alergi",
    "allergen": "Alergen",
    "allergenPlaceholder": "Mis. Penisilin, Kacang Tanah",
    "type": "Jenis",
    "typeOptions": {
      "drug": "Obat",
      "food": "Makanan",
      "environmental": "Lingkungan"
    },
    "severityLabel": "Tingkat Keparahan",
    "severity": {
      "mild": "Ringan",
      "moderate": "Sedang",
      "severe": "Berat",
      "lifeThreatening": "Mengancam Jiwa"
    },
    "reaction": "Reaksi",
    "reactionPlaceholder": "Mis. Biduran, Anafilaksis, Mual",
    "reactionOptions": {
      "rash": "Ruam",
      "hives": "Biduran",
      "anaphylaxis": "Anafilaksis",
      "swelling": "Pembengkakan",
      "itching": "Gatal",
      "other": "Lainnya"
    },
    "onsetDate": "Tanggal Awitan",
    "notes": "Catatan",
    "notesPlaceholder": "Catatan tambahan...",
    "verifiedBy": "Diverifikasi Oleh",
    "noKnownAllergies": "Tidak Ada Alergi yang Diketahui",
    "savedSuccess": "Alergi berhasil ditambahkan",
    "saveError": "Gagal menambahkan alergi",
    "deletedSuccess": "Alergi dihapus"
  },
  "components": {
    "allergyBadge": {
      "title": "{{name}} ({{type}}) - {{severity}}"
    },
    "bradenScale": {
      "title": "Skala Braden (Risiko Cedera Tekanan)",
      "footer": "Rentang total: 6-23. Skor yang lebih rendah menunjukkan risiko cedera tekanan yang lebih tinggi.",
      "scoreFormat": "Skor: {{score}} — {{riskBand}}",
      "riskBand": {
        "veryHigh": "Risiko Sangat Tinggi",
        "high": "Risiko Tinggi",
        "moderate": "Risiko Sedang",
        "mild": "Risiko Ringan",
        "none": "Tanpa Risiko"
      },
      "subscales": {
        "sensoryPerception": {
          "label": "{{n}}. Persepsi Sensorik",
          "options": {
            "1": "{{n}} - Sangat terbatas",
            "2": "{{n}} - Terbatas",
            "3": "{{n}} - Sedikit terbatas",
            "4": "{{n}} - Tidak ada gangguan"
          }
        },
        "moisture": {
          "label": "{{n}}. Kelembapan",
          "options": {
            "1": "{{n}} - Selalu lembap",
            "2": "{{n}} - Sangat lembap",
            "3": "{{n}} - Kadang lembap",
            "4": "{{n}} - Jarang lembap"
          }
        },
        "activity": {
          "label": "{{n}}. Aktivitas",
          "options": {
            "1": "{{n}} - Tirah baring",
            "2": "{{n}} - Hanya bisa duduk",
            "3": "{{n}} - Kadang berjalan",
            "4": "{{n}} - Sering berjalan"
          }
        },
        "mobility": {
          "label": "{{n}}. Mobilitas",
          "options": {
            "1": "{{n}} - Tidak bisa bergerak",
            "2": "{{n}} - Sangat terbatas",
            "3": "{{n}} - Sedikit terbatas",
            "4": "{{n}} - Tanpa batasan"
          }
        },
        "nutrition": {
          "label": "{{n}}. Nutrisi",
          "options": {
            "1": "{{n}} - Sangat buruk",
            "2": "{{n}} - Mungkin tidak cukup",
            "3": "{{n}} - Cukup",
            "4": "{{n}} - Sangat baik"
          }
        },
        "frictionShear": {
          "label": "{{n}}. Friksi & Geseran",
          "options": {
            "1": "{{n}} - Bermasalah",
            "2": "{{n}} - Berpotensi bermasalah",
            "3": "{{n}} - Tidak ada masalah jelas"
          }
        }
      }
    },
    "morseFallScale": {
      "title": "Skala Jatuh Morse",
      "scoreFormat": "Skor: {{score}} — {{riskBand}}",
      "subscales": {
        "historyOfFalling": {
          "label": "{{n}}. Riwayat Jatuh",
          "options": {
            "0": "Tidak ({{score}})",
            "25": "Ya ({{score}})"
          }
        },
        "secondaryDiagnosis": {
          "label": "{{n}}. Diagnosis Sekunder",
          "options": {
            "0": "Tidak ({{score}})",
            "15": "Ya ({{score}})"
          }
        },
        "ambulatoryAid": {
          "label": "{{n}}. Alat Bantu Berjalan",
          "options": {
            "0": "Tidak ada / Tirah baring / Bantuan perawat ({{score}})",
            "15": "Kruk / Tongkat / Alat bantu jalan ({{score}})",
            "30": "Berpegangan pada perabot ({{score}})"
          }
        },
        "ivHeparinLock": {
          "label": "{{n}}. Infus / Heparin Lock",
          "options": {
            "0": "Tidak ({{score}})",
            "20": "Ya ({{score}})"
          }
        },
        "gait": {
          "label": "{{n}}. Cara Berjalan",
          "options": {
            "0": "Normal / Tirah baring / Kursi roda ({{score}})",
            "10": "Lemah ({{score}})",
            "20": "Terganggu ({{score}})"
          }
        },
        "mentalStatus": {
          "label": "{{n}}. Status Mental",
          "options": {
            "0": "Sadar akan kemampuan diri sendiri ({{score}})",
            "15": "Melebih-lebihkan / Lupa keterbatasan ({{score}})"
          }
        }
      },
      "interventions": {
        "high": "Intervensi Risiko Tinggi: Terapkan pencegahan jatuh standar. Pasang gelang risiko jatuh pada pasien. Pasang tanda risiko jatuh di samping tempat tidur. Edukasi pasien dan keluarga. Posisikan tempat tidur pada posisi terendah dengan rem terkunci. Pastikan tombol panggilan terjangkau. Alas kaki anti slip. Jadwal toileting. Pertimbangkan pengawasan 1:1 jika perlu.",
        "moderate": "Intervensi Risiko Sedang: Terapkan pencegahan jatuh standar. Pasang gelang risiko jatuh pada pasien. Edukasi pasien dan keluarga. Posisikan tempat tidur pada posisi terendah dengan rem terkunci. Pastikan tombol panggilan terjangkau. Alas kaki anti slip.",
        "low": "Intervensi Risiko Rendah: Perawatan keperawatan dasar yang baik. Edukasi pasien tentang mobilitas aman. Orientasi lingkungan dan penggunaan tombol panggilan."
      }
    }
  },
  "banner": {
    "label": "Informasi pasien",
    "vip": "VIP",
    "vipTitle": "Pasien VIP",
    "mrn": "MRN",
    "dob": "DOB",
    "ageSuffix": "th",
    "sex": "Jenis Kelamin",
    "codeStatusAria": "Status kode: {{status}}",
    "isolationAria": "Isolasi: {{status}}",
    "isolation": {
      "contact": "Kontak",
      "droplet": "Droplet",
      "airborne": "Udara",
      "none": "Tidak ada"
    },
    "fallRiskAria": "Risiko jatuh: {{level}}",
    "fallRisk": {
      "label": "Risiko Jatuh",
      "low": "Rendah",
      "moderate": "Sedang",
      "high": "Tinggi"
    },
    "pressureInjuryRisk": "Risiko Cedera Tekanan",
    "pressureInjuryRiskAria": "Risiko cedera tekanan: {{level}}",
    "interpreter": "Penerjemah",
    "interpreterRequired": "Memerlukan penerjemah — {{language}}",
    "languageNotSpecified": "bahasa belum ditentukan",
    "weightKg": "{{weight}} kg",
    "allergiesLabel": "Alergi",
    "moreAllergies_one": "+{{count}} lagi",
    "moreAllergies_other": "+{{count}} lagi",
    "nkda": "NKDA",
    "allergiesUnknown": "Alergi tidak diketahui — gagal dimuat"
  },
  "chartFrame": {
    "navAriaLabel": "Navigasi rekam medis pasien",
    "tabs": {
      "summary": "Ringkasan",
      "encounters": "Kunjungan",
      "orders": "Instruksi",
      "results": "Hasil",
      "medications": "Obat",
      "notes": "Catatan",
      "problems": "Daftar Masalah",
      "allergies": "Alergi",
      "immunizations": "Imunisasi",
      "intakeOutput": "Asupan/Keluaran",
      "carePlans": "Rencana Perawatan",
      "referrals": "Rujukan",
      "familyHistory": "Riwayat Keluarga",
      "socialHistory": "Riwayat Sosial",
      "surgicalHistory": "Riwayat Bedah",
      "advanceDirectives": "Arahan Lanjutan",
      "insurance": "Asuransi",
      "contacts": "Kontak",
      "proxies": "Wakil",
      "identifiers": "Identifikasi",
      "addresses": "Alamat",
      "consents": "Consents",
      "pregnancyStatus": "Pregnancy",
      "implantableDevices": "Perangkat",
      "ccdaImports": "Impor C-CDA"
    },
    "groups": {
      "clinical": "Klinis",
      "history": "Riwayat",
      "admin": "Administrasi"
    },
    "breakGlass": {
      "auditBanner": "AKSES DARURAT — Seluruh aktivitas sedang diaudit. Akses berakhir dalam 15 menit.",
      "dialogTitle": "Rekam Medis Terbatas",
      "dialogSubtitle": "Memerlukan akses darurat",
      "dialogBody": "Rekam medis pasien ini dibatasi. Anda harus memberikan alasan untuk mengaksesnya. Semua akses darurat dicatat dan diaudit.",
      "justificationLabel": "Alasan",
      "justificationPlaceholder": "Masukkan alasan klinis untuk mengakses rekam medis terbatas ini...",
      "justificationRequired": "Alasan diperlukan untuk akses darurat.",
      "requestError": "Gagal meminta akses darurat. Silakan coba lagi atau hubungi administrator.",
      "submitButton": "Akses Rekam Medis",
      "submitting": "Memproses...",
      "passwordLabel": "Konfirmasi kata sandi Anda",
      "passwordPlaceholder": "Masukkan kembali kata sandi Anda",
      "passwordRequired": "Kata sandi Anda diperlukan untuk akses darurat.",
      "passwordIncorrect": "Kata sandi salah. Silakan coba lagi.",
      "passwordHelp": "Memastikan bahwa Anda yang berada di workstation ini.",
      "totpLabel": "Kode autentikator",
      "totpPlaceholder": "Kode 6 digit",
      "totpRequired": "Kode autentikator Anda diperlukan untuk akses darurat.",
      "totpIncorrect": "Kode salah. Silakan coba lagi.",
      "totpHelp": "Memastikan bahwa Anda yang berada di workstation ini.",
      "totpEnrollHint": "Belum ada autentikator terdaftar — daftarkan di Profil Saya untuk menggunakan akses darurat."
    },
    "invalidId": {
      "title": "ID Pasien Tidak Valid",
      "body": "ID pasien yang diberikan tidak valid.",
      "action": "Cari Pasien"
    },
    "notFound": {
      "title": "Pasien Tidak Ditemukan",
      "body": "Tidak dapat memuat data pasien. Pasien mungkin tidak ada atau Anda tidak memiliki akses.",
      "action": "Cari Pasien"
    },
    "loadError": {
      "title": "Gagal Memuat Bagan Pasien",
      "body": "Bagan tidak dapat dimuat. Silakan coba lagi.",
      "action": "Coba lagi"
    }
  },
  "address": {
    "title": "Alamat",
    "addAddress": "Tambah Alamat",
    "newTitle": "Alamat Baru",
    "editTitle": "Edit Alamat",
    "loading": "Memuat alamat...",
    "loadError": "Gagal memuat informasi alamat.",
    "empty": "Belum ada alamat.",
    "addressType": {
      "label": "Jenis",
      "values": {
        "home": "Rumah",
        "work": "Kantor",
        "temporary": "Sementara",
        "billing": "Penagihan"
      }
    },
    "fields": {
      "addressLine1": "Alamat Baris 1",
      "addressLine2": "Alamat Baris 2",
      "addressLine3": "Alamat Baris 3",
      "district": "Kecamatan",
      "city": "Kota",
      "stateProvince": "Provinsi",
      "postalCode": "Kode Pos",
      "country": "Negara"
    },
    "placeholders": {
      "addressLine1": "Alamat jalan",
      "addressLine2": "Apt, unit, lantai",
      "addressLine3": "Gedung, blok",
      "district": "Kecamatan/kelurahan",
      "postalCode": "mis. 12345",
      "country": "mis. ID"
    },
    "primaryBadge": "Utama",
    "setPrimary": "Tetapkan sebagai alamat utama",
    "primaryHelper": "(alamat lain akan tidak lagi menjadi utama)",
    "fromLabel": "Dari: {{date}}",
    "toLabel": "Sampai: {{date}}",
    "save": "Simpan",
    "update": "Perbarui",
    "cancel": "Batal",
    "editTooltip": "Edit alamat",
    "removeTooltip": "Hapus alamat",
    "addedSuccess": "Alamat ditambahkan",
    "addError": "Gagal menambahkan alamat",
    "updatedSuccess": "Alamat diperbarui",
    "updateError": "Gagal memperbarui alamat",
    "removedSuccess": "Alamat dihapus",
    "removeError": "Gagal menghapus alamat",
    "requiredError": "Alamat baris 1 dan negara wajib diisi",
    "confirmRemoveTitle": "Hapus Alamat",
    "confirmRemoveMessage": "Yakin ingin menghapus alamat {{type}} ini?",
    "confirmRemoveLabel": "Hapus"
  },
  "allergies": {
    "pageTitle": "Alergi",
    "addAllergy": "Tambah Alergi",
    "loading": "Memuat alergi...",
    "loadError": "Gagal memuat informasi alergi.",
    "nka": {
      "title": "Tidak Ada Alergi yang Diketahui (NKA)",
      "body": "Belum ada alergi yang dicatat untuk pasien ini."
    },
    "sections": {
      "active": "Alergi Aktif ({{count}})",
      "inactive": "Alergi Tidak Aktif ({{count}})"
    },
    "fields": {
      "reaction": "Reaksi",
      "severity": "Tingkat Keparahan",
      "onset": "Onset",
      "recorded": "Tanggal Dicatat"
    },
    "inactiveSummary": "Reaksi: {{reaction}} | Tingkat Keparahan: {{severity}}",
    "deactivate": "Nonaktifkan",
    "deactivateTooltip": "Nonaktifkan alergi",
    "deleteTooltip": "Hapus alergi",
    "deactivatedSuccess": "Alergi dinonaktifkan",
    "deactivateError": "Gagal menonaktifkan alergi",
    "removedSuccess": "Alergi dihapus",
    "removeError": "Gagal menghapus alergi",
    "confirmDeactivateTitle": "Konfirmasi Penonaktifan",
    "confirmDeactivateMessage": "Yakin ingin menonaktifkan \"{{name}}\"?",
    "confirmDeleteTitle": "Konfirmasi Penghapusan",
    "confirmDeleteMessage": "Yakin ingin menghapus \"{{name}}\" secara permanen?",
    "confirmLabel": "Konfirmasi"
  },
  "problems": {
    "pageTitle": "Daftar Masalah",
    "addProblem": "Tambah Masalah",
    "loading": "Memuat daftar masalah...",
    "loadError": "Gagal memuat daftar masalah.",
    "tabs": {
      "active": "Aktif ({{count}})",
      "resolvedInactive": "Selesai / Tidak Aktif ({{count}})"
    },
    "sortByLabel": "Urutkan menurut:",
    "sortBy": {
      "onsetDate": "Tanggal Onset",
      "severity": "Tingkat Keparahan"
    },
    "status": {
      "label": "Status",
      "values": {
        "active": "Aktif",
        "resolved": "Selesai",
        "inactive": "Tidak Aktif"
      }
    },
    "empty": {
      "active": "Tidak ada masalah aktif yang dicatat.",
      "resolved": "Tidak ada masalah selesai atau tidak aktif."
    },
    "fields": {
      "onset": "Onset",
      "resolved": "Selesai"
    },
    "resolveButton": "Selesai",
    "reactivateButton": "Aktifkan Kembali",
    "resolveTooltip": "Tandai sebagai selesai",
    "reactivateTooltip": "Aktifkan kembali",
    "statusUpdatedSuccess": "Status masalah diperbarui",
    "statusUpdateError": "Gagal memperbarui status masalah"
  },
  "immunizations": {
    "pageTitle": "Imunisasi",
    "addImmunization": "Tambah Imunisasi",
    "loading": "Memuat rekam imunisasi...",
    "loadError": "Gagal memuat rekam imunisasi.",
    "empty": "Tidak ada rekam imunisasi ditemukan.",
    "dueOverdue": "Imunisasi Jatuh Tempo / Terlambat ({{count}})",
    "upcoming": "Imunisasi Mendatang ({{count}})",
    "dueLabel": "Jatuh tempo: {{date}}",
    "fromDateLabel": "Dari Tanggal",
    "toDateLabel": "Sampai Tanggal",
    "fromDateAria": "Tanggal mulai imunisasi",
    "toDateAria": "Tanggal akhir imunisasi",
    "clearFilters": "Hapus",
    "cvxLabel": "CVX: {{code}}",
    "columns": {
      "vaccine": "Vaksin",
      "date": "Tanggal",
      "lotNumber": "No. Lot",
      "site": "Lokasi",
      "administeredBy": "Diberikan Oleh",
      "nextDue": "Jadwal Berikutnya",
      "status": "Status"
    },
    "dueStatus": {
      "label": "Status",
      "values": {
        "overdue": "Terlambat",
        "dueToday": "Jatuh Tempo Hari Ini",
        "upcoming": "Mendatang"
      }
    }
  },
  "contacts": {
    "pageTitle": "Kontak",
    "addContact": "Tambah Kontak",
    "loading": "Memuat kontak...",
    "loadError": "Gagal memuat informasi kontak.",
    "empty": "Belum ada kontak.",
    "emergencyBadge": "Darurat",
    "sections": {
      "emergency": "Kontak Darurat ({{count}})",
      "other": "Kontak Lain ({{count}})"
    },
    "editTooltip": "Edit kontak",
    "deleteTooltip": "Hapus kontak",
    "deletedSuccess": "Kontak dihapus",
    "deleteError": "Gagal menghapus kontak",
    "confirmDeleteTitle": "Hapus Kontak",
    "confirmDeleteMessage": "Yakin ingin menghapus \"{{name}}\"?",
    "confirmDeleteLabel": "Hapus"
  },
  "insurances": {
    "pageTitle": "Asuransi",
    "addInsurance": "Tambah Asuransi",
    "loading": "Memuat informasi asuransi...",
    "loadError": "Gagal memuat informasi asuransi.",
    "empty": {
      "title": "Tidak Ada Paket Asuransi",
      "body": "Belum ada paket asuransi yang dicatat untuk pasien ini."
    },
    "sections": {
      "active": "Paket Aktif ({{count}})",
      "inactive": "Paket Tidak Aktif ({{count}})"
    },
    "status": {
      "label": "Status",
      "values": {
        "active": "Aktif",
        "inactive": "Tidak Aktif",
        "pendingVerification": "Menunggu Verifikasi"
      }
    },
    "fields": {
      "memberId": "ID Anggota",
      "groupNumber": "Nomor Grup",
      "effectiveDate": "Tanggal Berlaku",
      "terminationDate": "Tanggal Berakhir",
      "copay": "Copay",
      "coinsurance": "Koinsuransi",
      "deductible": "Deductible",
      "subscriber": "Pemegang Polis"
    },
    "preAuthBadge": "Memerlukan Otorisasi Awal",
    "lastVerifiedLabel": "Diverifikasi terakhir: {{date}}",
    "copayAmount": "${{amount}}",
    "coinsurancePercent": "{{percent}}%",
    "deductibleAmount": "${{amount}}",
    "verifyButton": "Verifikasi",
    "verifyTooltip": "Verifikasi kelayakan",
    "editButton": "Edit",
    "verifySuccess": "Verifikasi kelayakan dimulai",
    "verifyError": "Verifikasi kelayakan gagal"
  },
  "identifiersTab": {
    "pageTitle": "Identifier",
    "addIdentifier": "Tambah Identifier",
    "loading": "Memuat identifier...",
    "loadError": "Gagal memuat informasi identifier.",
    "empty": "Belum ada identifier.",
    "newTitle": "Identifier Baru",
    "type": {
      "label": "Jenis",
      "selectPlaceholder": "Pilih jenis...",
      "values": {
        "externalMrn": "MRN Eksternal",
        "insuranceId": "ID Asuransi",
        "studyId": "ID Studi",
        "healthCard": "Kartu Kesehatan",
        "nationalRegistry": "Registri Nasional",
        "passport": "Paspor",
        "driverLicense": "SIM",
        "other": "Lainnya"
      }
    },
    "fields": {
      "value": "Nilai",
      "assigningAuthority": "Otoritas Penerbit",
      "effectiveDate": "Tanggal Berlaku",
      "expiryDate": "Tanggal Kedaluwarsa"
    },
    "placeholders": {
      "value": "mis. 1234567890",
      "assigningAuthority": "mis. Kemenkes"
    },
    "status": {
      "label": "Status",
      "values": {
        "active": "Aktif",
        "inactive": "Tidak Aktif"
      }
    },
    "columns": {
      "type": "Jenis",
      "value": "Nilai",
      "assigningAuthority": "Otoritas Penerbit",
      "effectiveDate": "Tanggal Berlaku",
      "expiryDate": "Tanggal Kedaluwarsa",
      "status": "Status",
      "actions": "Aksi"
    },
    "save": "Simpan",
    "cancel": "Batal",
    "removeTooltip": "Hapus identifier",
    "addedSuccess": "Identifier ditambahkan",
    "addError": "Gagal menambahkan identifier",
    "removedSuccess": "Identifier dihapus",
    "removeError": "Gagal menghapus identifier",
    "requiredError": "Jenis dan nilai wajib diisi",
    "confirmRemoveTitle": "Hapus Identifier",
    "confirmRemoveMessage": "Yakin ingin menghapus \"{{type}}: {{value}}\"?",
    "confirmRemoveLabel": "Hapus"
  },
  "pages": {
    "advanceDirectives": {
      "title": "Arahan Medis Lanjutan",
      "addButton": "Tambah Arahan",
      "emptyState": "Belum ada arahan medis lanjutan yang tercatat untuk pasien ini.",
      "loading": "Memuat arahan medis lanjutan...",
      "loadError": "Gagal memuat arahan medis lanjutan.",
      "documentLink": "Lihat Dokumen",
      "effectivePrefix": "Berlaku:",
      "reviewPrefix": "Tinjau:",
      "form": {
        "title": "Arahan Medis Lanjutan Baru",
        "labels": {
          "directiveType": "Jenis Arahan",
          "status": "Status",
          "effectiveDate": "Tanggal Berlaku",
          "notes": "Catatan",
          "optional": "opsional"
        },
        "placeholders": {
          "notes": "Catatan tambahan tentang arahan..."
        },
        "selectTypePlaceholder": "Pilih jenis...",
        "aria": {
          "effectiveDate": "Tanggal Berlaku"
        },
        "buttons": {
          "save": "Simpan Arahan",
          "cancel": "Batal"
        }
      },
      "directiveType": {
        "DNR": "Jangan Resusitasi (DNR)",
        "living-will": "Wasiat Hidup",
        "POLST": "POLST / MOLST",
        "healthcare-proxy": "Wakil Layanan Kesehatan",
        "power-of-attorney": "Surat Kuasa Tahan Lama"
      },
      "directiveStatus": {
        "active": "Aktif",
        "inactive": "Tidak Aktif",
        "revoked": "Dicabut",
        "pending": "Menunggu Tinjauan"
      },
      "toast": {
        "added": "Arahan medis lanjutan ditambahkan",
        "addFailed": "Gagal menambahkan arahan medis lanjutan",
        "directiveTypeRequired": "Jenis arahan wajib diisi"
      }
    },
    "familyHistory": {
      "title": "Riwayat Keluarga",
      "addButton": "Tambah Entri",
      "emptyState": "Tidak ada riwayat keluarga yang tercatat untuk pasien ini.",
      "loading": "Memuat riwayat keluarga...",
      "loadError": "Gagal memuat riwayat keluarga.",
      "onsetAge": "Usia onset: {{age}} tahun",
      "outcomePrefix": "Hasil:",
      "form": {
        "title": "Entri Riwayat Keluarga Baru",
        "labels": {
          "relationship": "Hubungan",
          "conditionName": "Nama Kondisi",
          "conditionCode": "Kode Kondisi",
          "onsetAge": "Usia Onset",
          "outcome": "Hasil",
          "optional": "opsional"
        },
        "placeholders": {
          "onsetAge": "Usia dalam tahun"
        },
        "selectRelationshipPlaceholder": "Pilih hubungan...",
        "selectOutcomePlaceholder": "Pilih hasil...",
        "buttons": {
          "save": "Simpan Entri",
          "cancel": "Batal"
        }
      },
      "relationship": {
        "Mother": "Ibu",
        "Father": "Ayah",
        "Sibling": "Saudara Kandung",
        "Maternal Grandmother": "Nenek (dari pihak ibu)",
        "Maternal Grandfather": "Kakek (dari pihak ibu)",
        "Paternal Grandmother": "Nenek (dari pihak ayah)",
        "Paternal Grandfather": "Kakek (dari pihak ayah)",
        "Child": "Anak",
        "Aunt": "Bibi",
        "Uncle": "Paman"
      },
      "outcome": {
        "alive": "Hidup",
        "deceased": "Meninggal",
        "unknown": "Tidak Diketahui"
      },
      "toast": {
        "added": "Entri riwayat keluarga ditambahkan",
        "addFailed": "Gagal menambahkan entri riwayat keluarga",
        "relationshipAndConditionRequired": "Hubungan dan kondisi wajib diisi"
      }
    },
    "socialHistory": {
      "title": "Riwayat Sosial",
      "editButton": "Sunting",
      "loading": "Memuat riwayat sosial...",
      "loadError": "Gagal memuat riwayat sosial.",
      "labels": {
        "smokingStatus": "Status Merokok",
        "alcoholUse": "Penggunaan Alkohol",
        "substanceUse": "Penggunaan Zat",
        "housing": "Hunian",
        "employment": "Pekerjaan",
        "safetyScreening": "Skrining Keselamatan",
        "notes": "Catatan"
      },
      "placeholders": {
        "notes": "Catatan tambahan..."
      },
      "buttons": {
        "save": "Simpan Perubahan",
        "cancel": "Batal"
      },
      "toast": {
        "updated": "Riwayat sosial diperbarui",
        "updateFailed": "Gagal memperbarui riwayat sosial"
      },
      "smokingStatus": {
        "never": "Tidak Pernah Merokok",
        "former": "Mantan Perokok",
        "currentDaily": "Perokok Aktif Harian",
        "currentOccasional": "Perokok Aktif Sesekali",
        "unknown": "Tidak Diketahui"
      },
      "alcoholUse": {
        "None": "Tidak Ada",
        "Social/Occasional": "Sosial/Kadang-kadang",
        "Moderate": "Sedang",
        "Heavy": "Berat",
        "In Recovery": "Dalam Pemulihan",
        "Unknown": "Tidak Diketahui"
      },
      "substanceUse": {
        "None": "Tidak Ada",
        "Current Use": "Penggunaan Saat Ini",
        "Former Use": "Penggunaan Sebelumnya",
        "In Treatment": "Dalam Perawatan",
        "Unknown": "Tidak Diketahui"
      },
      "housing": {
        "Stable": "Stabil",
        "Unstable": "Tidak Stabil",
        "Homeless": "Tunawisma",
        "Assisted Living": "Hunian Berbantuan",
        "Nursing Facility": "Fasilitas Perawatan",
        "Unknown": "Tidak Diketahui"
      },
      "employment": {
        "Employed Full-Time": "Bekerja Penuh Waktu",
        "Employed Part-Time": "Bekerja Paruh Waktu",
        "Self-Employed": "Wiraswasta",
        "Unemployed": "Tidak Bekerja",
        "Retired": "Pensiun",
        "Student": "Pelajar",
        "Disabled": "Difabel",
        "Unknown": "Tidak Diketahui"
      },
      "safetyScreening": {
        "No Concerns": "Tidak Ada Kekhawatiran",
        "Concerns Identified": "Kekhawatiran Teridentifikasi",
        "Declined to Answer": "Menolak Menjawab",
        "Not Screened": "Belum Diskrining"
      }
    },
    "surgicalHistory": {
      "title": "Riwayat Bedah",
      "addButton": "Tambah Prosedur",
      "emptyState": "Tidak ada riwayat bedah yang terdokumentasi untuk pasien ini.",
      "loading": "Memuat riwayat bedah...",
      "loadError": "Gagal memuat riwayat bedah.",
      "cptLabel": "CPT {{code}}",
      "dateLabel": "Tanggal: {{date}}",
      "surgeonLabel": "Ahli Bedah: {{name}}",
      "anesthesiaLabel": "Anestesi: {{type}}",
      "outcomePrefix": "Hasil:",
      "complicationsPrefix": "Komplikasi:",
      "form": {
        "title": "Entri Riwayat Bedah Baru",
        "labels": {
          "procedureName": "Nama Prosedur",
          "procedureCode": "Kode Prosedur",
          "procedureCodeSuffix": "(CPT)",
          "date": "Tanggal",
          "surgeonName": "Nama Ahli Bedah",
          "anesthesiaType": "Jenis Anestesi",
          "laterality": "Sisi",
          "outcome": "Hasil",
          "complications": "Komplikasi"
        },
        "placeholders": {
          "surgeonName": "Nama ahli bedah",
          "complications": "Komplikasi jika ada..."
        },
        "selectPlaceholder": "Pilih...",
        "aria": {
          "procedureDate": "Tanggal Prosedur"
        },
        "buttons": {
          "save": "Simpan Entri",
          "cancel": "Batal"
        }
      },
      "anesthesiaType": {
        "general": "Anestesi Umum",
        "regional": "Anestesi Regional",
        "local": "Anestesi Lokal",
        "spinal": "Anestesi Spinal",
        "epidural": "Anestesi Epidural",
        "sedation": "Sedasi",
        "none": "Tidak Ada",
        "unknown": "Tidak Diketahui"
      },
      "laterality": {
        "left": "Kiri",
        "right": "Kanan",
        "bilateral": "Bilateral"
      },
      "toast": {
        "added": "Entri riwayat bedah ditambahkan",
        "addFailed": "Gagal menambahkan entri riwayat bedah",
        "procedureNameRequired": "Nama prosedur wajib diisi"
      }
    },
    "referralManagement": {
      "title": "Rujukan",
      "addButton": "Rujukan Baru",
      "refresh": "Segarkan",
      "loading": "Memuat rujukan...",
      "errorState": "Gagal memuat rujukan.",
      "emptyState": "Tidak ada rujukan untuk pasien ini.",
      "emptyStateFiltered": "Tidak ada rujukan yang cocok dengan status terpilih.",
      "ariaFilterStatus": "Saring rujukan berdasarkan status",
      "externalBadge": "Eksternal",
      "filterStatus": {
        "allLabel": "Semua Status"
      },
      "table": {
        "type": "Jenis",
        "reason": "Alasan",
        "specialty": "Spesialisasi",
        "priority": "Prioritas",
        "status": "Status",
        "requested": "Diajukan",
        "target": "Target"
      },
      "form": {
        "title": "Rujukan Baru",
        "labels": {
          "referralType": "Jenis Rujukan",
          "priority": "Prioritas",
          "specialty": "Spesialisasi",
          "reason": "Alasan",
          "targetDate": "Tanggal Target",
          "clinicalNotes": "Catatan Klinis",
          "optional": "opsional"
        },
        "placeholders": {
          "reason": "Alasan rujukan",
          "clinicalNotes": "Catatan klinis tambahan..."
        },
        "selectReferralTypePlaceholder": "Pilih jenis...",
        "selectSpecialtyPlaceholder": "Pilih spesialisasi...",
        "buttons": {
          "create": "Buat Rujukan",
          "cancel": "Batal"
        }
      },
      "referralType": {
        "consultation": "Konsultasi",
        "transfer": "Pemindahan Perawatan",
        "second-opinion": "Pendapat Kedua",
        "diagnostic": "Diagnostik",
        "therapeutic": "Terapeutik"
      },
      "priority": {
        "routine": "Rutin",
        "urgent": "Mendesak",
        "stat": "STAT"
      },
      "status": {
        "draft": "Draf",
        "submitted": "Diajukan",
        "accepted": "Diterima",
        "scheduled": "Dijadwalkan",
        "completed": "Selesai",
        "cancelled": "Dibatalkan"
      },
      "toasts": {
        "createSuccess": "Rujukan dibuat",
        "createFailed": "Gagal membuat rujukan",
        "validationFailed": "Jenis rujukan dan alasan wajib diisi"
      }
    }
  },
  "consents": {
    "title": "Consents",
    "grant": "Grant consent",
    "revoke": "Revoke",
    "confirmRevoke": "Revoke this consent? This records a revocation event and cannot be undone.",
    "loading": "Loading consents…",
    "loadError": "Failed to load consents.",
    "empty": "No consent records for this patient.",
    "table": {
      "scope": "Scope",
      "category": "Category",
      "decision": "Decision",
      "status": "Status",
      "effective": "Effective",
      "recorded": "Recorded",
      "actions": "Actions",
      "history": "Event history"
    },
    "toast": {
      "revoked": "Consent revoked.",
      "revokeFailed": "Failed to revoke consent."
    },
    "scope": {
      "patientPrivacy": "Patient privacy",
      "research": "Research",
      "treatment": "Treatment",
      "adr": "Adverse drug reaction"
    },
    "decision": {
      "permit": "Permit",
      "deny": "Deny"
    },
    "status": {
      "draft": "Draft",
      "proposed": "Proposed",
      "active": "Active",
      "rejected": "Rejected",
      "inactive": "Inactive",
      "enteredInError": "Entered in error"
    },
    "eventType": {
      "granted": "Granted",
      "revoked": "Revoked",
      "evaluated": "Evaluated",
      "accessGranted": "Access granted",
      "accessDenied": "Access denied"
    },
    "events": {
      "loading": "Loading history…",
      "empty": "No events recorded."
    },
    "form": {
      "title": "Grant consent",
      "submit": "Grant consent",
      "savedSuccess": "Consent recorded.",
      "saveError": "Failed to record consent."
    },
    "fields": {
      "scope": "Scope",
      "decision": "Decision",
      "category": "Category",
      "categoryPlaceholder": "e.g. medical-records, imaging",
      "performer": "Performer",
      "performerPlaceholder": "e.g. Patient/123 or Practitioner/45",
      "purpose": "Purpose",
      "dataClass": "Data class",
      "effectiveFrom": "Effective from",
      "effectiveTo": "Effective to",
      "notes": "Notes"
    }
  },
  "pregnancy": {
    "title": "Pregnancy & Lactation Screening",
    "currentHeading": "Current status",
    "recordHeading": "Record a status",
    "historyHeading": "History",
    "pregnancyLabel": "Pregnancy",
    "lactationLabel": "Lactation",
    "eddLabel": "Estimated due date",
    "sourceLabel": "Source",
    "notesLabel": "Notes",
    "recordButton": "Record status",
    "recordedOn": "Recorded {{date}}",
    "eddOn": "Estimated due date {{date}}",
    "outOfDate": "Out of date",
    "neverAsked": "Never asked",
    "notRecorded": "Not recorded",
    "noHistory": "No screening has been recorded for this patient.",
    "savedSuccess": "Screening status recorded",
    "saveError": "Could not record the screening status",
    "status": {
      "pregnant": "Pregnant",
      "notPregnant": "Not pregnant",
      "unknown": "Not known",
      "declined": "Declined to answer",
      "notApplicable": "Not applicable"
    },
    "lactationStatus": {
      "lactating": "Lactating",
      "notLactating": "Not lactating",
      "unknown": "Not known",
      "declined": "Declined to answer",
      "notApplicable": "Not applicable"
    },
    "source": {
      "patientReported": "Patient reported",
      "clinician": "Clinician",
      "lab": "Laboratory"
    },
    "columns": {
      "recordedAt": "Recorded",
      "pregnancy": "Pregnancy",
      "lactation": "Lactation",
      "edd": "Due date",
      "source": "Source",
      "notes": "Notes"
    },
    "errors": {
      "notesTooLong": "Notes must be 1000 characters or fewer",
      "eddOnlyWhenPregnant": "An estimated due date applies only to a pregnant status"
    }
  },
  "nursingAssessment": {
    "title": "Nursing Assessment",
    "subtitle": "The Morse and Braden scores recorded here update this patient's risk badges.",
    "assessmentType": "Assessment type",
    "type": {
      "admission": "Admission",
      "shift": "Shift",
      "focused": "Focused",
      "discharge": "Discharge"
    },
    "levelOfConsciousness": "Level of consciousness",
    "loc": {
      "alert": "Alert",
      "drowsy": "Drowsy",
      "lethargic": "Lethargic",
      "confused": "Confused",
      "unresponsive": "Unresponsive"
    },
    "mobilityLevel": "Mobility",
    "mobility": {
      "independent": "Independent",
      "assistiveDevice": "Assistive device",
      "assistOfOne": "Assist of one",
      "assistOfTwo": "Assist of two",
      "bedbound": "Bedbound"
    },
    "fallRiskFactors": "Fall risk factors",
    "fallRiskFactorsPlaceholder": "e.g. unsteady gait, IV pole, sedation",
    "pressureInjuryPresent": "Pressure injury already present",
    "painAssessment": "Pain assessment",
    "painPlaceholder": "Site, character, score, intervention",
    "generalNotes": "General notes",
    "save": "Save assessment",
    "saving": "Saving…",
    "saved": "Assessment recorded",
    "saveFailed": "Could not record the assessment",
    "notClinical": "Your account has no clinical identity, so it cannot sign a nursing assessment.",
    "history": "Previous assessments",
    "historyEmpty": "No assessments recorded for this encounter yet.",
    "bands": "Fall: {{fall}} · Pressure: {{pressure}}",
    "notScored": "not scored"
  },
  "duplicates": {
    "title": "Duplicate Review",
    "subtitle": "Candidate duplicate records found by the matching scanner. Review each pair and merge, or record that they are different people.",
    "noPermission": "You do not have permission to review duplicate patient records.",
    "loading": "Loading candidates...",
    "loadFailed": "Could not load the duplicate worklist.",
    "empty": "No candidates to review.",
    "dismissed": "Decision recorded.",
    "dismissFailed": "Could not record the decision.",
    "prev": "Previous",
    "next": "Next",
    "pageOf": "Page {{page}} of {{totalPages}}",
    "columns": {
      "score": "Score",
      "patients": "Records",
      "matchedOn": "Matched on",
      "detected": "Detected",
      "actions": "Actions"
    },
    "filters": {
      "status": "Review status",
      "minScore": "Min score"
    },
    "status": {
      "pending": "Pending",
      "reviewed": "Reviewed",
      "merged": "Merged",
      "not_duplicate": "Not a duplicate",
      "ignored": "Ignored"
    },
    "confidence": {
      "very_high": "Very high",
      "high": "High",
      "medium": "Medium",
      "low": "Low"
    },
    "matchedField": {
      "nameMatch": "Name",
      "dobMatch": "Date of birth",
      "genderMatch": "Gender",
      "nationalIdMatch": "National ID",
      "phoneMatch": "Phone",
      "addressMatch": "Address"
    },
    "actions": {
      "review": "Review",
      "dismiss": "Not a duplicate"
    },
    "dismissDialog": {
      "title": "Record a review decision",
      "body": "{{name1}} ({{mrn1}}) and {{name2}} ({{mrn2}}) will be removed from the worklist.",
      "reasonHelp": {
        "not_duplicate": "These are different people. The pair will not return unless the matching evidence materially improves.",
        "ignored": "Do not action this pair for now. Same suppression rule applies."
      },
      "notesPlaceholder": "Notes (optional)",
      "cancel": "Cancel",
      "confirm": "Record decision"
    },
    "restricted": {
      "title_one": "{{count}} pasangan melibatkan pasien yang tidak dapat Anda lihat",
      "title_other": "{{count}} pasangan melibatkan pasien yang tidak dapat Anda lihat",
      "body": "Salah satu pasien Anda mungkin duplikat dari rekam medis di fasilitas lain. Pasangan itu tidak ditampilkan karena menilainya berarti melihat pasien di luar akses Anda — mintalah Manajemen Informasi Kesehatan meninjaunya."
    }
  },
  "__review_duplicateReview": "Duplicate-review worklist copy — ships English pending market sign-off; 'merge' vs 'link' is a records-management register that differs by market.",
  "recordExport": {
    "button": "Ekspor rekam medis",
    "exporting": "Mengekspor…",
    "success": "Rekam medis diekspor",
    "failed": "Ekspor gagal — tidak ada yang diunduh",
    "tooltip": "Unduh rekam medis lengkap pasien ini sebagai berkas portabel"
  },
  "device": {
    "addTitle": "Catat Perangkat Implan",
    "editTitle": "Catat Eksplan",
    "deviceName": "Nama perangkat",
    "deviceNamePlaceholder": "cth., Evera MRI ICD, stent elusi obat",
    "deviceNameTooLong": "Nama perangkat maksimal 512 karakter",
    "deviceType": "Jenis perangkat",
    "deviceTypePlaceholder": "cth., alat pacu jantung, stent, prostesis",
    "udi": "UDI",
    "udiPlaceholder": "Pembawa Identifikasi Perangkat Unik",
    "deviceCode": "Kode perangkat",
    "deviceCodeSystem": "Sistem kode",
    "deviceCodeSystemPlaceholder": "cth., GMDN, SNOMED CT",
    "manufacturer": "Pabrikan",
    "modelNumber": "Model",
    "lotNumber": "No. lot",
    "serialNumber": "No. seri",
    "implantDate": "Tanggal implan",
    "explantDate": "Tanggal eksplan",
    "status": "Status",
    "statusOptions": {
      "active": "Aktif",
      "inactive": "Nonaktif",
      "explanted": "Dieksplan"
    },
    "mriSafety": "Keamanan MRI",
    "mriSafetyOptions": {
      "safe": "Aman",
      "conditional": "Bersyarat",
      "unsafe": "Tidak aman",
      "unknown": "Tidak diketahui"
    },
    "notes": "Catatan",
    "notesPlaceholder": "Catatan tambahan...",
    "savedSuccess": "Perangkat berhasil dicatat",
    "saveError": "Gagal mencatat perangkat",
    "updatedSuccess": "Eksplan berhasil dicatat",
    "updateError": "Gagal mencatat eksplan",
    "explantRequiresDate": "Perangkat yang dieksplan memerlukan tanggal eksplan",
    "explantBeforeImplant": "Tanggal eksplan tidak boleh sebelum tanggal implan"
  },
  "devices": {
    "pageTitle": "Perangkat Implan",
    "addDevice": "Catat Perangkat",
    "loading": "Memuat perangkat...",
    "loadError": "Gagal memuat informasi perangkat.",
    "empty": {
      "title": "Tidak Ada Perangkat Implan",
      "body": "Tidak ada perangkat yang dicatat untuk pasien ini."
    },
    "sections": {
      "active": "Perangkat Aktif ({{count}})",
      "history": "Dieksplan / Nonaktif ({{count}})"
    },
    "fields": {
      "udi": "UDI",
      "manufacturer": "Pabrikan",
      "implanted": "Diimplan",
      "explanted": "Dieksplan",
      "mriSafety": "Keamanan MRI",
      "recorded": "Dicatat"
    },
    "recordExplant": "Catat eksplan",
    "explantTooltip": "Catat pengeluaran perangkat ini",
    "removeTooltip": "Hapus entri",
    "removedSuccess": "Entri perangkat dihapus",
    "removeError": "Gagal menghapus entri perangkat",
    "confirmDeleteTitle": "Konfirmasi Penghapusan",
    "confirmDeleteMessage": "Hapus \"{{name}}\" dari daftar? Hapus hanya entri yang dicatat karena kesalahan — untuk mencatat pengeluaran dari tubuh, gunakan Catat eksplan.",
    "confirmLabel": "Konfirmasi"
  },
  "ccdaImports": {
    "title": "Impor C-CDA",
    "subtitle": "Dokumen diterima untuk rekonsiliasi. Buka impor untuk meninjau setiap entri ke dalam rekam medis.",
    "empty": "Tidak ada dokumen impor untuk pasien ini.",
    "loadError": "Gagal memuat impor.",
    "received": "Diterima",
    "docType": "Jenis",
    "status": "Status",
    "pending": "Tertunda",
    "entries": "Entri",
    "match": "Kecocokan",
    "mismatch": "ID tidak cocok",
    "statuses": {
      "pending": "Tertunda",
      "reviewed": "Ditinjau",
      "dismissed": "Dibuang"
    },
    "docTypes": {
      "ccd": "CCD",
      "referral-note": "Catatan rujukan",
      "discharge-summary": "Ringkas-pulang",
      "other": "Lainnya"
    }
  },
  "ccdaReview": {
    "title": "Impor #{{id}}",
    "back": "Kembali ke impor",
    "loadError": "Gagal memuat impor ini.",
    "mismatchWarning": "Pengenal pengirim tidak cocok dengan pasien ini. Pastikan dokumen ini miliknya sebelum menerima apa pun.",
    "unnamed": "Entri tanpa nama",
    "accept": "Terima",
    "reject": "Tolak",
    "accepted": "Entri digabungkan ke rekam medis",
    "rejected": "Entri ditolak",
    "alreadyReviewed": "Sudah ditinjau orang lain — diperbarui di bawah",
    "reviewError": "Tinjauan gagal",
    "confirmAcceptTitle": "Terima ke rekam medis?",
    "confirmAcceptMessage": "“{{name}}” akan ditambahkan ke rekam medis pasien ini.",
    "confirmRejectTitle": "Tolak entri ini?",
    "confirmRejectMessage": "“{{name}}” akan dihapus dari antrean. Dokumen mentah tetap tersimpan.",
    "sections": {
      "problem": "Masalah",
      "medication": "Obat-obatan",
      "allergy": "Alergi"
    },
    "statuses": {
      "accepted": "Diterima",
      "rejected": "Ditolak"
    }
  }
}
